export const types = {
    SET_GET_BONUS_CODE: '[BONUS CODE] SET GET BONUS CODE',
    SET_GET_BONUS_CODE_BY_ID: '[BONUS CODE] SET GET BONUS CODE BY ID'
}